export default "__VITE_ASSET__BQulezkw__"